import { Feature, isEnabled } from "core/features";
import ActiveFeatures from "./actives-features";

const getActiveFeatures = () => {
    const statements = isEnabled(Feature.dashboard_statements);

    const features: ActiveFeatures = {
        fixError: isEnabled(Feature.dashboard_clearError),
        downloadStatements: statements && isEnabled(Feature.dashboard_statements_download),
        statements: statements,
        users: isEnabled(Feature.users),
        queries: isEnabled(Feature.support),
        pay: isEnabled(Feature.makePayment),
        activityLog: isEnabled(Feature.users_activity_log)
    }

    return features;
}

export default getActiveFeatures; 
